import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {LoadingService} from "../services/loading.service";
import {finalize} from "rxjs/operators";

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  constructor(private loadingService: LoadingService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isRefreshTokenRequest = this.isRefreshTokenRequest(request);
    const skipLoading = request.headers.has('X-Skip-Loading');

    if (!isRefreshTokenRequest && !skipLoading) {
      this.loadingService.show();
    }

    return next.handle(request).pipe(
      finalize(() => {
        if (!isRefreshTokenRequest && !skipLoading) {
          this.loadingService.hide();
        }
      })
    );
  }

  private isRefreshTokenRequest = (request: HttpRequest<any>) => {
    if (request.method === 'POST') {
      if (typeof request.body === 'string') {
        const params = new URLSearchParams(request.body);
        return params.get('grant_type') === 'refresh_token';
      } else if (request.body && typeof request.body === 'object') {
        return request.body.grant_type === 'refresh_token';
      }
    }
    return false;
  }
}
